import { render, staticRenderFns } from "./refuteResourcesCar.vue?vue&type=template&id=40c59753&scoped=true&"
import script from "./refuteResourcesCar.vue?vue&type=script&lang=js&"
export * from "./refuteResourcesCar.vue?vue&type=script&lang=js&"
import style0 from "./refuteResourcesCar.vue?vue&type=style&index=0&id=40c59753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c59753",
  null
  
)

export default component.exports